import { atomWithReset } from "jotai/utils";

export const claimIntegrationStatusModalAtom = atomWithReset<{
  visible: boolean;
  claimId: string | null;
}>({
  visible: false,
  claimId: null
});
